import React from 'react';

import Toast from '.';

const renderToast = (type, message, autoClose = null, setToastVisibility) => {
  if (autoClose) {
    setTimeout(() => {
      setToastVisibility(false);
    }, autoClose + 1500);
  }

  return (
    <Toast type={type} message={message} autoClose={autoClose} hideProgress />
  );
};

export { renderToast };
